import { render, staticRenderFns } from "./Legal-entities-list.vue?vue&type=template&id=6f50d2de&scoped=true"
import script from "./Legal-entities-list.vue?vue&type=script&lang=js"
export * from "./Legal-entities-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f50d2de",
  null
  
)

export default component.exports